import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import NousConnaitre from "@/pages/NousConnaitre";
import NosActions from "@/pages/NosActions";
import NotreActualite from "@/pages/NotreActualite";
import NousRejoindre from "@/pages/NousRejoindre";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "UNSA Domitys";
    const observer = new MutationObserver(() => {
      if (document.title !== "UNSA Domitys") {
        document.title = "UNSA Domitys";
      }
    });
    const titleEl = document.querySelector("title");
    if (titleEl) {
      observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
    }
    return () => observer.disconnect();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin route without Layout */}
        <Route path="/admin" element={<AdminPage />} />

        {/* Public routes with Layout */}
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/nous-connaitre" element={<NousConnaitre />} />
              <Route path="/nos-actions" element={<NosActions />} />
              <Route path="/nos-actions/:id" element={<NosActions />} />
              <Route path="/notre-actualite" element={<NotreActualite />} />
              <Route path="/notre-actualite/:id" element={<NotreActualite />} />
              <Route path="/nous-rejoindre" element={<NousRejoindre />} />
            </Routes>
          </Layout>
        } />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
